"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerCardList = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const index_1 = require("../index");
require("./index.scss");
const className = 'front-partner-card-list';
class PartnerCardList extends react_1.default.PureComponent {
    render() {
        const { modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames }, this.props.cards.map(card => (react_1.default.createElement("div", { key: card.name },
            react_1.default.createElement(index_1.PartnerCard, { image: card.image, name: card.name }))))));
    }
}
exports.PartnerCardList = PartnerCardList;
//# sourceMappingURL=index.js.map